const mod = require('../../bahabot.module.js');

function bbChipsInputController() {
    const $ctrl = this;

    const VALID_CHIP_REGEX = /^[a-zA-Z0-9\-_]+$/;

    $ctrl.$onInit = () => {
        if (!$ctrl.model) $ctrl.model = [];
        $ctrl.input = '';
    };

    $ctrl.onKeyDown = function (event) {
        const key = event.key;
        const addBySpace = $ctrl.addOnSpace === 'true';
        const addByComma = $ctrl.addOnComma === 'true';

        const shouldAdd =
            (addBySpace && key === ' ') ||
            (addByComma && key === ',') ||
            key === 'Enter';

        if (shouldAdd) {
            event.preventDefault();
            $ctrl.addChipFromInput();
            return;
        }

        // Handle backspace to edit last chip
        if (key === 'Backspace' && !$ctrl.input) {
            event.preventDefault();
            const last = $ctrl.model.pop();
            if (last) {
                $ctrl.input = last;
            }
        }
    };

    $ctrl.onPaste = function (event) {
        const text = (event.clipboardData || window.clipboardData).getData('text');
        const parts = text.split(/[\s,]+/).map(s => s.trim());

        const validParts = parts.filter(p =>
            VALID_CHIP_REGEX.test(p) && !$ctrl.model.includes(p)
        );

        if (validParts.length) {
            $ctrl.model.push(...validParts);
        }

        event.preventDefault();
        $ctrl.input = '';
    };

    $ctrl.addChipFromInput = () => {
        const value = $ctrl.input.trim();
        const isValid = VALID_CHIP_REGEX.test(value);

        if (value && isValid && !$ctrl.model.includes(value)) {
            $ctrl.model.push(value);
        }

        $ctrl.input = '';
    };

    $ctrl.removeChip = (index) => {
        $ctrl.model.splice(index, 1);
    };
}

mod.component('bbChipsInput', {
    template: `
    <div class="flex flex-wrap gap-2 p-2 bg-slate-800 rounded border border-slate-700 focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500">
        <span ng-repeat="chip in $ctrl.model track by $index" class="bg-blue-700 text-white text-sm px-2 py-1 rounded-full flex items-center focus:ring focus:ring-blue-500">
            {{chip}}
            <button type="button" class="ml-2 text-xs hover:text-red-300" ng-click="$ctrl.removeChip($index)">✕</button>
        </span>
        <input type="text"
               ng-attr-id="{{$ctrl.id}}"
               ng-model="$ctrl.input"
               placeholder="{{$ctrl.placeholder}}"
               ng-keydown="$ctrl.onKeyDown($event)"
               ng-paste="$ctrl.onPaste($event)"
               class="min-w-[8ch] flex-grow bg-transparent text-white text-sm px-2 py-1 rounded focus:outline-none " />
    </div>
    `,
    bindings: {
        id: "@",
        model: "=",
        placeholder: "@",
        addOnSpace: "@",
        addOnComma: "@"
    },
    controller: [bbChipsInputController]
});
